import axios from '@/utils/axiosInstance';
import type { WebsiteLayout } from '@/types/websiteLayout';

export const getWebsiteLayout = async (signal?: AbortSignal): Promise<WebsiteLayout> => {
  const response = await axios.get<WebsiteLayout>('/api/website-layout', { signal });
  return response.data;
};

export const saveWebsiteLayout = async (layout: WebsiteLayout): Promise<WebsiteLayout> => {
  const response = await axios.put<WebsiteLayout>('/api/website-layout', layout);
  return response.data;
};

export const resetWebsiteLayout = async (revision: number): Promise<WebsiteLayout> => {
  const response = await axios.post<WebsiteLayout>('/api/website-layout/reset', { revision });
  return response.data;
};
